document.addEventListener("DOMContentLoaded", function() {
    function userAcceptedCookies() {
        if( localStorage.getItem('cookiesAccepted') === 'true' ) {
            return true;
        }
        return false;
    }

    function setCookiesAccepted() {
        localStorage.setItem('cookiesAccepted', 'true');
    }

    if( !userAcceptedCookies() ) {
        const cookiesNotice = document.querySelector('#cookiesNotice');
        const btnAcceptCookies = document.querySelector('#btnAcceptCookies');
        const btnRejectCookies = document.querySelector('#btnRejectCookies');

        cookiesNotice.classList.remove('v--hidden');

        btnAcceptCookies.addEventListener('click', function(e) {
            e.preventDefault();
            setCookiesAccepted();
            cookiesNotice.classList.add('v--hidden');
        });

        btnRejectCookies.addEventListener('click', function(e) {
            e.preventDefault();
            cookiesNotice.classList.add('v--hidden');
        });
    }
});